import styled from 'styled-components'

export const Wrap = styled.div`
  display: flex;
  align-items: center;
`
export const Checkbox = styled.input``
export const Label = styled.div``
